import styled from 'styled-components'

export const StyledBackIcon = styled.svg`
  position: absolute;
  transform: rotate(90deg);
  top: 24px;
  left: 20px;
  width: 34px;
  height: 34px;
  cursor: pointer;
`
